// Global settings utility - read/write app settings

const PREFIX = 'qtalk_setting_';

export const getSetting = (key, defaultVal) => {
  try {
    const v = localStorage.getItem(PREFIX + key);
    return v !== null ? JSON.parse(v) : defaultVal;
  } catch { return defaultVal; }
};

export const setSetting = (key, val) => {
  try { localStorage.setItem(PREFIX + key, JSON.stringify(val)); } catch {}
};

// Apply all settings to DOM immediately
export const applySettings = () => {
  // Font size
  const FONT_SIZES = [12, 13, 14, 15, 16];
  const fontSize = getSetting('fontSize', 3);
  document.documentElement.style.setProperty('--qtalk-font-size', FONT_SIZES[fontSize-1] + 'px');

  // Compact mode
  const compact = getSetting('compactMode', false);
  document.documentElement.classList.toggle('qtalk-compact', compact);

  // High contrast
  const hc = getSetting('highContrast', false);
  document.documentElement.classList.toggle('qtalk-high-contrast', hc);

  // Reduce motion
  const rm = getSetting('reduceMotion', false);
  document.documentElement.classList.toggle('qtalk-reduce-motion', rm);
};

// Call on app load
applySettings();
